export default "__VITE_ASSET__42e46bbb__"